<template>
  <v-card>
    <v-card-title>
      <v-container>
        <v-row  justify="center">
          <v-col cols="12">
            <v-img :src="require('@/assets/logo_dark.png')" alt="logo" width="150px" class="mx-auto mt-9"></v-img>
          </v-col>
          <v-col cols="12">
            <h2 class="title text-center font-weight-bold primary--text">
              {{ $t('LoginPage.Form.header') }}
            </h2>
          </v-col>
          <v-col cols="12">
            <h5 class="subtitle-1 text-center">
              {{ $t('LoginPage.Form.subheader') }}
            </h5>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-form>
        <v-text-field
          prepend-icon="alternate_email"
          name="login"
          :label="$t('LoginPage.Form.identifier')"
          type="text"
          v-model="username"
          :disabled="require2FA"
          @keyup.enter="login"
        ></v-text-field>
        <v-text-field
          id="password"
          prepend-icon="lock"
          name="password"
          :label="$t('LoginPage.Form.password')"
          type="password"
          v-model="password"
          :disabled="require2FA"
          @keyup.enter="login"
        ></v-text-field>
        <v-slide-y-transition>
          <v-text-field
            v-if="require2FA"
            id="auth_code"
            prepend-icon="vpn_key"
            name="auth_code"
            :label="$t('LoginPage.Form.code')"
            :hint="$t('LoginPage.Form.hintCode')"
            persistent-hint
            type="text"
            v-model="authCode"
            @keyup.enter="login2FA"
          ></v-text-field>
        </v-slide-y-transition>

      </v-form>
    </v-card-text>
    <v-card-actions class="px-4">
      <v-spacer></v-spacer>
      <v-btn v-if="!require2FA" text @click="forgotPassword">
        {{ $t('LoginPage.Button.forgotten') }}
      </v-btn>
      <v-btn color="primary" :loading="loading" @click="submit" :disabled="!canSubmit">
        {{ $t('LoginPage.Button.tologin') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { INVALID_CREDENTIALS, MAX_LOGIN_ATTEMPTS } from '@/config/errors'
import { AuthService } from '@portal/api'
export default {
  name: 'TheLoginForm',
  data: () => ({
    username: '',
    password: '',
    loading: false,
    require2FA: false,
    authCode: ''
  }),
  computed: {
    canSubmit () {
      return this.username && this.password && !this.loading && (!this.require2FA || this.authCode)
    }
  },
  methods: {
    ...mapActions('auth', [
      'connectUser'
    ]),
    submit() {
      this.require2FA ? this.login2FA() : this.login()
    },
    async login () {
      if (this.canSubmit) {
        this.loading = true
        try {
          const result = await AuthService.login(this.username, this.password)
          if (result.require2FA) {
            this.require2FA = true
          } else {
            await this.connectUser()
            this.$emit('logged')
          }
        } catch (error) {
          if (error?.response?.data?.error === INVALID_CREDENTIALS) {
            this.$emit('error', this.$t('LoginPage.Error.invalid'))
          } else if (error?.response?.data?.error === MAX_LOGIN_ATTEMPTS) {
            this.$emit('error', this.$t('LoginPage.Error.maxAttempts'))
          } else {
            this.$emit('error', this.$t('LoginPage.Error.failed'))
          }
        }
        this.loading = false
      }
    },
    async login2FA() {
      this.loading = true
      try {
        await AuthService.login2FA(this.authCode)
        await this.connectUser()
        this.$emit('logged')
      } catch (error) {
        this.$emit('error', this.$t('LoginPage.Error.invalid'))
      }
      this.loading = false
    },
    forgotPassword () {
      this.$emit('forgotPassword')
    }
  }
}
</script>
